import type { AppConfig } from "./types/index";

export const appConfig: AppConfig = {
  provider: "googleSheets",
  defaultRole: "forecaster", // viewer | forecaster | admin
  refreshIntervalMs: 5 * 60 * 1000,
  googleSheets: {
    endpoint: "/api/sheets",
    spreadsheetId: "",
    sheets: {
      assets: "Assets",
      forecasts: "Forecasts",
      rules: "Forecasts_Rules",
      accessRules: "Access_Rules",
      dataAccessRules: "Data_Access_Rules",
      configAsset: "Config_Asset",
      configTranslation: "Config_Translation",
      configLanguage: "Config_Language",
      auditLog: "Audit_Log",
      comments: "Comments",
      notifications: "Notifications"
    }
  },
};
